<script>
  import { onDestroy, onMount } from "svelte";
  import ItemResponse from "./ItemResponse.svelte";
  import { Label, Input, Collapse } from "sveltestrap";
  import { currentSpec } from "../../editor/storage";
  export let inputFocusAction,
    inputBlurAction,
    axisItem,
    updateAxis,
    isSerializable,
    currAxisToEdit;

  let newCustomValue, newCustomText;

  let showAxisDesign = true;
  let showAxisTitle = true;
  let showTextDesign = axisItem?.textDesign.map((_) => true);
  let showTextLine = axisItem?.textDesign.map((a) => a.items?.map((_) => true));
  onMount(() => {
    if (!showTextDesign) {
      showTextDesign = axisItem?.textDesign.map((_) => true);
      showTextLine = axisItem?.textDesign.map((a) => a.items?.map((_) => true));
    }
    newCustomValue = undefined;
    newCustomText = undefined;
  });
  onDestroy(() => {
    newCustomValue = undefined;
    newCustomText = undefined;
  });
  $: {
    showTextDesign = axisItem?.textDesign.map(
      (_, i) => showTextDesign?.[i] || false
    );
    showTextLine = axisItem?.textDesign.map((a, i) =>
      a.items?.map((_, j) => showTextLine?.[i]?.[j] || false)
    );
    newCustomValue = undefined;
    newCustomText = undefined;
  }
  console.log(axisItem);
</script>

<!-- Axis Design -->
<div class="dupo-menu-pane">
  <div class="dupo-menu-pane-form-row">
    <button
      type="button"
      class="menu-second-level"
      on:click={() => {
        showAxisDesign = !showAxisDesign;
      }}
    >
      <i class={`bi bi-caret-${showAxisDesign ? "down-fill" : "right"}`} />
      Axis design</button
    >
  </div>
</div>
<!-- offset: number -->
<Collapse isOpen={showAxisDesign}>
  <!-- <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="size"
      token="offset"
      title="Offset (from chart)"
      {inputFocusAction}
      {inputBlurAction}
      value={axisItem.axisDesign.offset}
      changeAction={(event) => {
        updateAxis(event, "axis.offset", axisItem);
      }}
    />
  </div> -->
  <!-- domain: boolean -->
  <div class="dupo-menu-pane">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Domain</h3>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      token="domain"
      title="Use domain"
      {inputFocusAction}
      {inputBlurAction}
      value={axisItem.axisDesign?.domain}
      changeAction={(event) => {
        updateAxis(event, "axis.domain", axisItem);
      }}
    />
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      token="offset"
      title="Axis offset from chart"
      {inputFocusAction}
      {inputBlurAction}
      value={axisItem.axisDesign?.offset}
      changeAction={(event) => {
        updateAxis(event, "axis.offset", axisItem);
      }}
    />
  </div>
  {#if axisItem.axisDesign?.domain}
    <!-- domainColor: color -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="color"
        token="domainColor"
        title="Domain color"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign?.domainColor || "rgba(0,0,0,1)"}
        changeAction={(event) => {
          updateAxis(event, "axis.domain.color", axisItem);
        }}
      />
    </div>
    <!-- domainWidth: number -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="width"
        token="domainWidth"
        title="Domain width"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign?.domainWidth}
        changeAction={(event) => {
          updateAxis(event, "axis.domain.width", axisItem);
        }}
      />
    </div>
    <!-- domainOpacity: number[0--1] -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="opacity"
        token="domainOpacity"
        title="Domain opacity"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign?.domainOpacity || 1}
        changeAction={(event) => {
          updateAxis(event, "axis.domain.opacity", axisItem);
        }}
      />
    </div>
    <!-- domainDash: dash array -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="dash"
        token="domainDash"
        title="Domain dash"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign?.domainDash}
        changeAction={(event) => {
          updateAxis(event, "axis.domain.dash", axisItem);
        }}
      />
    </div>
  {/if}
  <div class="pane-divider" />
  <!-- grid: boolean -->
  <div class="dupo-menu-pane">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Grid</h3>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      token="grid"
      title="Use grid"
      {inputFocusAction}
      {inputBlurAction}
      value={axisItem.axisDesign?.grid}
      changeAction={(event) => {
        updateAxis(event, "axis.grid", axisItem);
      }}
    />
  </div>
  {#if axisItem.axisDesign?.grid}
    <!-- gridColor: color -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="color"
        token="gridColor"
        title="Grid color"
        {inputFocusAction}
        {inputBlurAction}
        pickerX="290px"
        value={axisItem.axisDesign.gridColor || "rgba(0,0,0,1)"}
        changeAction={(event) => {
          updateAxis(event, "axis.grid.color", axisItem);
        }}
      />
    </div>
    <!-- gridWidth: number -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="width"
        token="gridWidth"
        title="Grid width"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign.gridWidth}
        changeAction={(event) => {
          updateAxis(event, "axis.grid.width", axisItem);
        }}
      />
    </div>
    <!-- gridOpacity: number[0--1] -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="opacity"
        token="gridOpacity"
        title="Grid opacity"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign.gridOpacity || 1}
        changeAction={(event) => {
          updateAxis(event, "axis.grid.opacity", axisItem);
        }}
      />
    </div>
    <!-- gridDash: dash array -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="dash"
        token="gridDash"
        title="Grid dash"
        {inputFocusAction}
        {inputBlurAction}
        value={axisItem.axisDesign.gridDash}
        changeAction={(event) => {
          updateAxis(event, "axis.grid.dash", axisItem);
        }}
      />
    </div>
  {/if}
</Collapse>

{#if $currentSpec.fronto.layout?.[{ row: "column", column: "row" }[axisItem.role]]?.length == 2}
  <div class="pane-divider" />
  <!-- repeat: boolean -->
  <div class="dupo-menu-pane">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Repeat</h3>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      token="repeat"
      title={`Repeat over ${{ row: "column", column: "row" }[axisItem.role]}`}
      {inputFocusAction}
      {inputBlurAction}
      value={axisItem.axisDesign?.repeat}
      changeAction={(event) => {
        updateAxis(event, "axis.repeat", axisItem);
      }}
    />
  </div>
{/if}
<!-- text design -->

<div class="pane-divider" />
<!-- Use labels -->
<div class="dupo-menu-pane">
  <ItemResponse
    type="inline-check"
    token="labels"
    title="Use axis labels and ticks"
    {inputFocusAction}
    {inputBlurAction}
    value={axisItem.textDesign.length > 0}
    changeAction={(event) => {
      updateAxis(event, "axis.label", axisItem);
    }}
  />
</div>
<!-- "anchor": "start", "padding": 30, "orient": "top", -->

{#if axisItem.textDesign.length > 0}
  {#each axisItem.textDesign as textItem, ti}
    <!-- global -->
    <div class="dupo-menu-pane">
      <div class="dupo-menu-pane-form-row">
        <button
          type="button"
          class="menu-second-level"
          on:click={() => {
            showTextDesign[ti] = !showTextDesign[ti];
          }}
          ><i
            class={`bi bi-caret-${showTextDesign[ti] ? "down-fill" : "right"}`}
          />Axis label {ti + 1}</button
        >
      </div>
    </div>
    <Collapse isOpen={showTextDesign[ti]}>
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-row">
          <h3 class="h-sub">Overall appearance</h3>
        </div>
      </div>
      <!-- values -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="text"
          token={"values-" + ti}
          title="Values"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.values?.join(",") || ""}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.values`, axisItem);
          }}
        />
      </div>
      <!-- anchor: start, middle, end -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="anchor"
          token={"anchor-" + ti}
          title="Anchor"
          sme3pos={true}
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.anchor}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.anchor`, axisItem);
          }}
        />
      </div>
      <!-- orient: top.... -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="orient"
          token={"orient-" + ti}
          title="Orient"
          topBottom={true}
          leftRight={true}
          tblr6pos={true}
          tblr4pos={false}
          center={false}
          none={false}
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.orient}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.orient`, axisItem);
          }}
        />
      </div>
      <!-- angle -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="angle"
          token={"angle-" + ti}
          title="Angle"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.angle}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.angle`, axisItem);
          }}
        />
      </div>
      <!-- padding: number > 0-->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="size"
          token={"padding-" + ti}
          title="Offset from axis"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.padding}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.padding`, axisItem);
          }}
        />
      </div>
      <!-- dx -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="unitNumber"
          title="Relative X positoin (dx)"
          token="dx"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.dx}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.dx`, axisItem);
          }}
        />
      </div>
      <!-- dy -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="unitNumber"
          title="Relative Y positoin (dy)"
          token="dy"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.dy}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.dy`, axisItem);
          }}
        />
      </div>
      <!-- dy -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="color"
          title="Background color"
          token="background-color"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.fill}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.fill`, axisItem);
          }}
        />
      </div>
      <!-- Serialization! for bar/square/image/rect marks only -->
      {#if isSerializable}
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="inline-check"
            token="serialize"
            title="Serialize axis labels"
            {inputFocusAction}
            {inputBlurAction}
            value={axisItem.axisDesign?.serial}
            changeAction={(event) => {
              updateAxis(event, `axis.label.${ti}.serial`, axisItem);
            }}
          />
        </div>
      {/if}

      <div class="pane-divider" />
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-row">
          <h3 class="h-sub">Text by line</h3>
        </div>
      </div>
      {#if textItem.items}
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="select"
            token={"flex-" + ti}
            title="Align lines"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.flex}
            optionNames={[
              "Vertical (default)",
              "Horizontal-Start",
              "Horizontal-Center",
              "Horizontal-End",
              "Horizontal-Space between",
              "Horizontal",
            ]}
            options={[
              "vertical",
              "horizontal-start",
              "horizontal-center",
              "horizontal-end",
              "horizontal-space-between",
              "horizontal",
            ]}
            changeAction={(event) => {
              updateAxis(event, `axis.label.${ti}.flex`, axisItem);
            }}
          />
        </div>
        {#each textItem.items as item, ii}
          <!-- per Item -->
          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-form-row">
              <button
                type="button"
                class="menu-second-level"
                on:click={() => {
                  showTextLine[ti][ii] = !showTextLine[ti][ii];
                }}
                ><i
                  class={`bi bi-caret-${
                    showTextLine[ti][ii] ? "down-fill" : "right"
                  }`}
                />Text line {ii + 1}</button
              >
            </div>
          </div>
          <Collapse isOpen={showTextLine[ti][ii]}>
            <!-- values -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="text"
                token={"values-" + ti + "-" + ii}
                title="Values"
                {inputFocusAction}
                {inputBlurAction}
                value={item.values?.join(",") || ""}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.values`,
                    axisItem
                  );
                }}
              />
            </div>

            <div class="dupo-menu-pane">
              <div class="dupo-menu-pane-row">
                <h3 class="h-sub">Layout</h3>
              </div>
            </div>

            <!-- width -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="width"
                token={"width-" + ti + "-" + ii}
                title="Width"
                {inputFocusAction}
                {inputBlurAction}
                value={item.width}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.width`,
                    axisItem
                  );
                }}
              />
            </div>

            <!-- text-align -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="textAlign"
                token={"textAlign-" + ti + "-" + ii}
                title="Text align"
                {inputFocusAction}
                {inputBlurAction}
                value={item.align}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.align`,
                    axisItem
                  );
                }}
              />
            </div>

            <div class="dupo-menu-pane mt-3">
              <div class="dupo-menu-pane-row">
                <h3 class="h-sub">Font style</h3>
              </div>
            </div>

            <!-- font size -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="fontSize"
                token={"fontSize-" + ti + "-" + ii}
                title="Font size"
                {inputFocusAction}
                {inputBlurAction}
                value={item.fontSize || 16}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.fontSize`,
                    axisItem
                  );
                }}
              />
            </div>

            <!-- font-weight -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="fontWeight"
                token={"fontWeight-" + ti + "-" + ii}
                title="Font weight"
                {inputFocusAction}
                {inputBlurAction}
                value={item.fontWeight}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.fontWeight`,
                    axisItem
                  );
                }}
              />
            </div>

            <!-- line height -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="size"
                token={"lineHeight-" + ti + "-" + ii}
                title="Line height (%)"
                {inputFocusAction}
                {inputBlurAction}
                value={item.lineHeight}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.lineHeight`,
                    axisItem
                  );
                }}
              />
            </div>

            <!-- color -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="color"
                token={"color-" + ti + "-" + ii}
                title="Font color"
                {inputFocusAction}
                {inputBlurAction}
                pickerX="290px"
                value={item.color || "rgba(0,0,0,1)"}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.color`,
                    axisItem
                  );
                }}
              />
            </div>

            <!-- opacity -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="opacity"
                token={"opacity-" + ti + "-" + ii}
                title="Opacity"
                {inputFocusAction}
                {inputBlurAction}
                value={item.opacity || 1}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.opacity`,
                    axisItem
                  );
                }}
              />
            </div>

            <div class="dupo-menu-pane mt-3">
              <div class="dupo-menu-pane-row">
                <h3 class="h-sub">Text formatting</h3>
              </div>
            </div>

            <!-- format string -->
            <div class="dupo-menu-pane mb-2">
              <ItemResponse
                type="text"
                token={"format-" + ti + "-" + ii}
                title="Format string"
                {inputFocusAction}
                {inputBlurAction}
                value={item.format}
                changeAction={(event) => {
                  updateAxis(
                    event,
                    `axis.label.${ti}.items.${ii}.format`,
                    axisItem
                  );
                }}
              />
            </div>

            {#if axisItem.field}
              <!-- expression -->
              <div class="dupo-menu-pane mb-2">
                <ItemResponse
                  type="data-expression"
                  token={"expression-" + ti + "-" + ii}
                  title="Expression"
                  {inputFocusAction}
                  {inputBlurAction}
                  value={item.expression}
                  field={axisItem.field}
                  values={item.values || []}
                  changeAction={(event) => {
                    updateAxis(
                      event,
                      `axis.label.${ti}.items.${ii}.expression`,
                      axisItem
                    );
                  }}
                />
              </div>
            {/if}
            <!-- custom text -->
            <div class="dupo-menu-pane mb-2">
              <div class="dupo-menu-pane-row">
                <Label for={"custom-" + ti + "-" + ii}>Custom per value</Label>
              </div>

              {#if item.customList !== undefined}
                {#each item.customList as custom, ci}
                  <div class="dupo-menu-pane-form-row d-flex">
                    <Label
                      for={"custom-" + ti + "-" + ii + "-value-" + ci}
                      style="width: 43%;"
                      class="text-sm mb-0">Value {ci + 1}</Label
                    >
                    <Label
                      for={"custom-" + ti + "-" + ii + "-text-" + ci}
                      style="width: 53%;"
                      class="text-sm mb-0">Text {ci + 1}</Label
                    >
                    <Label style="width: 4%;" class="text-sm mb-0">-</Label>
                  </div>
                  <div class="dupo-menu-pane-form-row mb-1 d-flex">
                    <div class="form-wrap">
                      <Input
                        id={"custom-" + ti + "-" + ii + "-value-" + ci}
                        name={"custom-" + ti + "-" + ii + "-value-" + ci}
                        type="text"
                        autocomplete="off"
                        class="custom-form-select"
                        style="width: 40%;"
                        on:focus={inputFocusAction}
                        on:blur={inputBlurAction}
                        bind:value={custom.value}
                        on:change={(event) => {
                          updateAxis(
                            item.customList,
                            `axis.label.${ti}.items.${ii}.custom`,
                            axisItem
                          );
                        }}
                      />
                      <Input
                        id={"custom-" + ti + "-" + ii + "-text-" + ci}
                        name={"custom-" + ti + "-" + ii + "-text-" + ci}
                        type="text"
                        autocomplete="off"
                        class="custom-form-select"
                        style="width: 50%;"
                        on:focus={inputFocusAction}
                        on:blur={inputBlurAction}
                        bind:value={custom.text}
                        on:change={(event) => {
                          updateAxis(
                            item.customList,
                            `axis.label.${ti}.items.${ii}.custom`,
                            axisItem
                          );
                        }}
                      />
                      <button
                        type="button"
                        class="custom-form-select"
                        style="width: 10%; padding-left: 0; padding-right: 0;"
                        on:click={(event) => {
                          item.customList.splice(ci, 1);
                          updateAxis(
                            item.customList,
                            `axis.label.${ti}.items.${ii}.custom`,
                            axisItem
                          );
                        }}
                        ><i
                          class="bi bi-trash-fill"
                          alt="delete this custom item"
                        /></button
                      >
                    </div>
                  </div>
                {/each}
              {/if}
              <div class="dupo-menu-pane-form-row d-flex">
                <Label
                  for={"custom-" + ti + "-" + ii + "-value-new"}
                  style="width: 43%;"
                  class="text-sm mb-0">New value</Label
                >
                <Label
                  for={"custom-" + ti + "-" + ii + "-text-new"}
                  style="width: 53%;"
                  class="text-sm mb-0">New text</Label
                >
                <Label style="width: 4%;" class="text-sm mb-0">+</Label>
              </div>
              <div class="dupo-menu-pane-form-row mb-1 d-flex">
                <div class="form-wrap">
                  <Input
                    id={"custom-" + ti + "-" + ii + "-value-new"}
                    name={"custom-" + ti + "-" + ii + "-value-new"}
                    type="text"
                    autocomplete="off"
                    class="custom-form-select"
                    style="width: 40%;"
                    on:focus={inputFocusAction}
                    on:blur={inputBlurAction}
                    bind:value={newCustomValue}
                  />
                  <Input
                    id={"custom-" + ti + "-" + ii + "-text-new"}
                    name={"custom-" + ti + "-" + ii + "-text-new"}
                    type="text"
                    autocomplete="off"
                    class="custom-form-select"
                    style="width: 50%;"
                    on:focus={inputFocusAction}
                    on:blur={inputBlurAction}
                    bind:value={newCustomText}
                  />
                  <button
                    type="button"
                    class="custom-form-select"
                    style="width: 10%; padding-left: 0; padding-right: 0;"
                    on:click={(event) => {
                      updateAxis(
                        { newCustomValue, newCustomText },
                        `axis.label.${ti}.items.${ii}.custom`,
                        axisItem
                      );
                      newCustomValue = undefined;
                      newCustomText = undefined;
                    }}
                    ><i
                      class="bi bi-plus-circle"
                      alt="add this custom item"
                    /></button
                  >
                </div>
              </div>
            </div>

            <!-- deleting -->
            {#if textItem.items.length > 0}
              <div class="dupo-menu-pane mt-3">
                <div class="dupo-menu-pane-button-row">
                  <button
                    type="button"
                    on:click={(event) => {
                      updateAxis(
                        "remove",
                        `axis.label.${ti}.items.${ii}`,
                        axisItem
                      );
                    }}><i class="bi bi-eraser me-1" /> Delete this line</button
                  >
                </div>
              </div>
            {/if}
            <div class="pane-divider" />
          </Collapse>
        {/each}
      {/if}

      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-button-row">
          <button
            type="button"
            on:click={(event) => {
              updateAxis("add", `axis.label.${ti}.items`, axisItem);
            }}><i class="bi bi-plus-circle me-1" /> Add new line</button
          >
        </div>
      </div>

      <div class="pane-divider" />
      <!-- tick: boolean -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="inline-check"
          token={"tick-" + ti}
          title="Use tick"
          {inputFocusAction}
          {inputBlurAction}
          value={textItem.tick !== undefined}
          changeAction={(event) => {
            updateAxis(event, `axis.label.${ti}.tick`, axisItem);
          }}
        />
      </div>
      {#if textItem.tick !== undefined}
        <!-- tick values -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="text"
            token={"tickValues-" + ti}
            title="Tick values"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.tick?.tickValues?.join(",") || ""}
            changeAction={(event) => {
              updateAxis(event, `axis.label.${ti}.tick.tickValues`, axisItem);
            }}
          />
        </div>
        <!-- tickColor: color -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="color"
            token={"tickColor-" + ti}
            title="Tick color"
            {inputFocusAction}
            {inputBlurAction}
            pickerX="290px"
            value={textItem.tick.color || "rgba(0,0,0,1)"}
            changeAction={(event) => {
              updateAxis(event, `axis.label.${ti}.tick.color`, axisItem);
            }}
          />
        </div>
        <!-- tickWidth: number -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="width"
            token={"tickWidth-" + ti}
            title="Tick width"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.tick.width}
            changeAction={(event) => {
              updateAxis(event, `axis.label.${ti}.tick.width`, axisItem);
            }}
          />
        </div>
        <!-- tickOpacity: number[0--1] -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="opacity"
            token={"tickOpacity-" + ti}
            title="Tick opacity"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.tick.opacity || 1}
            changeAction={(event) => {
              updateAxis(event, `axis.label.${ti}.tick.opacity`, axisItem);
            }}
          />
        </div>
      {/if}

      <!-- axis title -->
      <div class="pane-divider" />
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-form-row">
          <button
            type="button"
            class="menu-second-level"
            on:click={() => {
              showAxisTitle = !showAxisTitle;
            }}
          >
            <i class={`bi bi-caret-${showAxisTitle ? "down-fill" : "right"}`} />
            Axis title</button
          >
        </div>
      </div>
      <Collapse isOpen={showAxisTitle}>
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="inline-check"
            token="use-title"
            title="Use title"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.title !== undefined}
            changeAction={(event) => {
              updateAxis(event, "axis.title", axisItem);
            }}
          />
        </div>
        {#if textItem.title !== undefined}
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="text"
              token="title-text"
              title="Title text"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.value}
              changeAction={(event) => {
                updateAxis(event, "axis.title.text", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="textAlign"
              token="title-align"
              title="Title align"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.align}
              changeAction={(event) => {
                updateAxis(event, "axis.title.textAlign", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="color"
              token="title-color"
              title="Title font color"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.color || "rgba(0,0,0,1)"}
              changeAction={(event) => {
                updateAxis(event, "axis.title.color", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="size"
              token="title-fontSize"
              title="Title font size"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.fontSize || 12}
              changeAction={(event) => {
                updateAxis(event, "axis.title.fontSize", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="fontWeight"
              token="title-fontWeight"
              title="Title font weight"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.fontWeight}
              changeAction={(event) => {
                updateAxis(event, "axis.title.fontWeight", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="opacity"
              token="title-opacity"
              title="Title opacity"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.opacity || 1}
              changeAction={(event) => {
                updateAxis(event, "axis.title.opacity", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="angle"
              token="title-rotate"
              title="Title rotate (deg)"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.rotate || 0}
              changeAction={(event) => {
                updateAxis(event, "axis.title.rotate", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="number"
              token="title-padding"
              title="Title offset (from axis)"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.padding}
              changeAction={(event) => {
                updateAxis(event, "axis.title.padding", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="number"
              token="title-x"
              title="Title X position"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.x}
              changeAction={(event) => {
                updateAxis(event, "axis.title.x", axisItem);
              }}
            />
          </div>
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="number"
              token="title-y"
              title="Title Y position"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.title?.y}
              changeAction={(event) => {
                updateAxis(event, "axis.title.y", axisItem);
              }}
            />
          </div>
        {/if}
      </Collapse>
    </Collapse>
  {/each}
{/if}

<!-- lock -->
<div class="pane-divider" />
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="lock"
    tooltipMessage="Prevent suggesting responsive alternatives that make changes to this axis' layout, grid, and tick (not label). Element-Lock applies to its source or target design(s)."
    title="Lock this axis design"
    token={"axis-lock"}
    value={axisItem.axisDesign?.lock}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateAxis(event, "axis.lock", axisItem);
    }}
  />
  <div class="dupo-menu-pane-row">
    <p class="text-sm">Applies to layout, grid, and tick only.</p>
  </div>
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="lock"
    tooltipMessage="Prevent suggesting responsive alternatives that make changes to this axis labels only. Element-Lock applies to its source or target design(s)."
    title="Lock this axis label design"
    token={"label-lock"}
    value={axisItem.textLock}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateAxis(event, "axis.label.lock", axisItem);
    }}
  />
</div>

<style>
  .color-name {
    max-width: 150px;
    overflow: hidden;
    vertical-align: middle;
    text-overflow: ellipsis;
  }
</style>
